export const MUTATION_GROUP = 'dateTimePickerFields' as const;
